<template>
  <v-card class="mb-8 pb-3">
    <v-row align="center" class="list px-3 mx-auto">
      <v-col cols="12" sm="5">
        <v-text-field
          v-model="searchName"
          :label="lang.SearchEmployee"
          :placeholder="lang.SearchEmployeeHint"
          append-icon="mdi-magnify"
          clearable
          hide-details
          @keyup.enter="doSearch"
          @click:append="doSearch"
          @click:clear="clearSearch"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="2">
        <v-btn small @click="doSearch">
          {{langC.Search}}
        </v-btn>
      </v-col>
      <v-col cols="6" sm="3">
        <span v-if="searched">{{lang.Found}}: {{rows.length}}</span>
        <span v-if="limitHit" class="red--text ml-2">{{lang.TooMany}}</span>
      </v-col>
      <v-col cols="12" sm="2">
        <v-progress-circular v-if="saving" indeterminate color="green" size="24"></v-progress-circular>
      </v-col>
    </v-row>

    <v-row v-if="searched" no-gutters>
      <v-col cols="12">
        <v-data-table
          dense
          :headers="headers"
          :items="rows"
          item-key="id"
          :items-per-page="20"
          :footer-props="{'items-per-page-options': [10, 20, 50, 100]}"
          :no-data-text="lang.NothingFound"
          @click:row="navigateTo"
          :mobile-breakpoint="0"
        >
          <template v-slot:[`item.Month`]="{ item }">
            <span class="purple--text">{{ parseInt(item.Month) }}</span>
          </template>
          <template v-slot:[`item.Year`]="{ item }">
            <span class="green--text">{{ parseInt(item.Year) }}</span>
          </template>
          <template v-slot:[`item.Locked`]="{ item }">
            <span v-if="item.Locked"><v-icon small>mdi-check</v-icon></span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" bottom :timeout="timeout" :color="color">
      {{ text }}
    </v-snackbar>
  </v-card>
</template>

<script>
import SalarieService from '@/services/SalarieService'
import langEn from './salarieDescEn'
import langHr from './salarieDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'

export default {
  name: 'salariesearch',
  data () {
    return {
      lang: {},
      langC: {},
      searchName: '',
      rows: [],
      headers: [],
      saving: false,
      searched: false,
      limitHit: false,
      snackbar: false,
      text: '',
      color: 'red',
      timeout: 4000
    }
  },
  mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.headers = [
      {text: this.lang.hashtag, value: 'hashtag', width: '160px'},
      {text: this.lang.First, value: 'First', width: '130px'},
      {text: this.lang.Last, value: 'Last', width: '150px'},
      {text: this.lang.VatID, value: 'VatID', width: '120px'},
      {text: this.lang.eemail, value: 'eemail', width: '200px'},
      {text: this.lang.Month, value: 'Month', width: '80px'},
      {text: this.lang.Year, value: 'Year', width: '80px'},
      {text: this.lang.Vrsta, value: 'vrsta', width: '160px'},
      {text: 'JOPPD', value: 'BrojJoppd', width: '90px'},
      {text: this.lang.Order, value: 'Order', width: '90px'},
      {text: this.lang.Locked, value: 'Locked', width: '70px'},
      {text: 'DbId', value: 'salarieID', width: '70px'}
    ]
  },
  methods: {
    async doSearch () {
      const term = this.searchName ? this.searchName.trim() : ''
      if (term.length === 0) {
        this.clearSearch()
        return
      }
      this.saving = true
      try {
        const query = {}
        query.CompanyId = this.$store.state.companyid
        query.searchName = term
        const {data} = await SalarieService.searchemp(query)
        this.rows = data && data.rows ? data.rows : []
        this.limitHit = this.rows.length >= 200
        this.searched = true
      } catch (err) {
        this.rows = []
        this.searched = true
        this.text = 'Error! ' + err
        this.color = 'red'
        this.snackbar = true
      }
      this.saving = false
    },

    clearSearch () {
      this.searchName = ''
      this.rows = []
      this.searched = false
      this.limitHit = false
    },

    // opens the salarie the employee line belongs to, exactly like SalarieList does
    async navigateTo (params) {
      if (!params || !params.salarie || !params.salarieID) {
        this.text = this.lang.NoSalarie
        this.color = 'red'
        this.snackbar = true
        return
      }
      const head = {...params.salarie}
      head.documentId = params.salarieID
      head.documentName = this.$store.state.documentActiv
      head.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + params.salarieID.toString()
      await this.$store.dispatch('setDocumentActivHead', head)
      await this.$store.dispatch('seteditItem', 1)
      this.$store.dispatch('setretPath', 'salarie')
      await this.$store.dispatch('setDatabaseDocID', params.salarieID)
      this.$router.push({
        name: 'salariedetail'
      })
    }
  }
}
</script>

<style scoped>
</style>
